import React, { useEffect, useState } from 'react';
// Datos para las notificaciones
const customers = [{
  name: 'Emily Johnson',
  location: 'California'
}, {
  name: 'Michael Williams',
  location: 'Texas'
}, {
  name: 'Sarah Miller',
  location: 'New York'
}, {
  name: 'David Brown',
  location: 'Florida'
}, {
  name: 'Jennifer Davis',
  location: 'Illinois'
}, {
  name: 'Robert Wilson',
  location: 'Ohio'
}, {
  name: 'Lisa Martinez',
  location: 'Arizona'
}, {
  name: 'Thomas Anderson',
  location: 'Washington'
}, {
  name: 'Patricia Taylor',
  location: 'Michigan'
}, {
  name: 'James Smith',
  location: 'Georgia'
}, {
  name: 'Charlotte Rodriguez',
  location: 'Florida'
}, {
  name: 'Daniel White',
  location: 'Colorado'
}];
const timeAgo = ['Just now', '2 minutes ago', '5 minutes ago', '10 minutes ago', '15 minutes ago'];
// URL de la imagen del libro
const bookImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/pUz2ycH78DhCGCtiWuR8CA/ChatGPT_Image_27_sept_2025%2C_23_41_42.webp';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [customer, setCustomer] = useState(customers[0]);
  const [time, setTime] = useState(timeAgo[0]);
  const [lastCustomerIndex, setLastCustomerIndex] = useState(-1);
  useEffect(() => {
    // Mostrar notificación cada 8-15 segundos
    const showNotification = () => {
      // Seleccionar cliente aleatorio diferente al anterior
      let randomIndex;
      do {
        randomIndex = Math.floor(Math.random() * customers.length);
      } while (randomIndex === lastCustomerIndex && customers.length > 1);
      const randomCustomer = customers[randomIndex];
      const randomTime = timeAgo[Math.floor(Math.random() * timeAgo.length)];
      setCustomer(randomCustomer);
      setTime(randomTime);
      setLastCustomerIndex(randomIndex);
      setVisible(true);
      // Ocultar después de 6 segundos (aumentado de 5 a 6)
      setTimeout(() => {
        setVisible(false);
      }, 6000);
    };
    // Primera notificación después de 3 segundos
    const initialTimeout = setTimeout(showNotification, 3000);
    // Configurar intervalo para mostrar notificaciones periódicamente
    const interval = setInterval(() => {
      const randomDelay = 8000 + Math.floor(Math.random() * 7000); // 8-15 segundos
      setTimeout(showNotification, randomDelay);
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [lastCustomerIndex]);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-md" data-id="element-274">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center animate-slide-in" data-id="element-275">
        <div className="w-12 h-12 rounded-md overflow-hidden mr-3 flex-shrink-0" data-id="element-276">
          <img src={bookImage} alt="Eat To Heal Book" className="w-full h-full object-cover" data-id="element-277" />
        </div>
        <div className="flex-1" data-id="element-278">
          <div className="flex justify-between items-start" data-id="element-279">
            <div data-id="element-280">
              <p className="text-gray-800 text-sm font-medium" data-id="element-281">
                {customer.name} • {customer.location}
              </p>
              <p className="text-gray-600 text-xs" data-id="element-282">Purchase made: $19.00</p>
              <p className="text-gray-500 text-xs italic" data-id="element-283">Eat To Heal</p>
            </div>
            <span className="text-gray-400 text-xs ml-3" data-id="element-284">{time}</span>
          </div>
        </div>
      </div>
      <style jsx data-id="element-285">{`
        @keyframes slideIn {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-in {
          animation: slideIn 0.5s ease-out forwards;
        }
      `}</style>
    </div>;
}